/** Mirror server/auth/adminPermissionMap.js for frontend action visibility. */

export const ADMIN_PERMISSIONS = {
  USERS_MANAGE: "users.manage",
  ROLES_MANAGE: "roles.manage",
  PERMISSIONS_VIEW: "permissions.view",
  SYSTEM_AUDIT_VIEW: "system.audit.view",
  NOTIFICATIONS_MANAGE: "notifications.manage",

  PRIVACY_REQUESTS_VIEW: "privacy.requests.view",
  PRIVACY_REQUESTS_MANAGE: "privacy.requests.manage",
  PRIVACY_EVIDENCE_VIEW: "privacy.evidence.view",
  PRIVACY_VENDORS_MANAGE: "privacy.vendors.manage",
  PRIVACY_LEGAL_HOLDS_MANAGE: "privacy.legal_holds.manage",
  PRIVACY_INCIDENTS_MANAGE: "privacy.incidents.manage",

  REAL_ESTATE_SOURCES_VIEW: "real_estate.sources.view",
  REAL_ESTATE_SOURCES_MANAGE: "real_estate.sources.manage",

  VEHICLE_LISTING_IDENTITY_VIEW: "vehicle_listing_identity.view",
  VEHICLE_LISTING_IDENTITY_REPAIR: "vehicle_listing_identity.repair",

  REAL_ESTATE_LISTINGS_VIEW: "real_estate.listings.view",
  REAL_ESTATE_LISTINGS_EDIT: "real_estate.listings.edit",
  REAL_ESTATE_LISTINGS_DISABLE: "real_estate.listings.disable",
  REAL_ESTATE_DUPLICATES_REVIEW: "real_estate.duplicates.review",
  REAL_ESTATE_HISTORY_VIEW: "real_estate.history.view",
  REAL_ESTATE_MARKET_TRENDS_VIEW: "real_estate.market_trends.view",

  WEATHER_LAYERS_VIEW: "weather.layers.view",
  WEATHER_LAYERS_MANAGE: "weather.layers.manage",
  WEATHER_RADAR_VIEW: "weather.radar.view",
  WEATHER_RAINFALL_VIEW: "weather.rainfall.view",
  WEATHER_ALERTS_VIEW: "weather.alerts.view",

  MAP_LAYERS_VIEW: "map.layers.view",
  MAP_LAYERS_MANAGE: "map.layers.manage",

  PARTNERS_VIEW: "partners.view",
  PARTNERS_MANAGE: "partners.manage",

  CLIENT_VIEWS_VIEW: "client_views.view",
  CLIENT_VIEWS_MANAGE: "client_views.manage",
  CLIENT_VIEWS_PUBLISH: "client_views.publish",

  CRM_VIEW: "crm.view",
  CRM_MANAGE_LEADS: "crm.manage_leads",
  CRM_MANAGE_OPPORTUNITIES: "crm.manage_opportunities",
  CRM_MANAGE_CONTACTS: "crm.manage_contacts",
  CRM_MANAGE_VENDORS: "crm.manage_vendors",
  CRM_MANAGE_REPORTS: "crm.manage_reports",
  CRM_ADMIN: "crm.admin",
  PARTNER_DASHBOARD_VIEW: "partner_dashboard.view",
  PARTNER_LISTINGS_VIEW: "partner_listings.view",
  PARTNER_LISTINGS_MANAGE: "partner_listings.manage",
  PARTNER_SOURCES_VIEW: "partner_sources.view",
  PARTNER_SOURCES_MANAGE: "partner_sources.manage",

  SAVED_SEARCHES_VIEW: "saved_searches.view",
  SAVED_SEARCHES_MANAGE: "saved_searches.manage",
  FAVORITES_VIEW: "favorites.view",
  FAVORITES_MANAGE: "favorites.manage",
};
